import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=fb0c0cd6&scoped=true"
import script from "./BankAccountList.vue?vue&type=script&lang=js"
export * from "./BankAccountList.vue?vue&type=script&lang=js"
import style0 from "./BankAccountList.vue?vue&type=style&index=0&id=fb0c0cd6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c0cd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb0c0cd6')) {
      api.createRecord('fb0c0cd6', component.options)
    } else {
      api.reload('fb0c0cd6', component.options)
    }
    module.hot.accept("./BankAccountList.vue?vue&type=template&id=fb0c0cd6&scoped=true", function () {
      api.rerender('fb0c0cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/BankAccountList.vue"
export default component.exports